import axios from "axios";

const request = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

request.interceptors.request.use(async (req) => {
  return req;
});

request.interceptors.response.use(
  async (res: any) => {
    return res.data;
  },
  async (error: any) => {
    return handleError(error);
  },
);

export const handleError = (e: any) => {
  if (e.response) {
    console.warn(`[Response Error From]: ${e.response.config.url}`);
    
    const status = e.response.data?.status || e.response.status || '';
    const message = e.response.data?.error || '';
    
    console.warn('[Response Error Message]: ' + message);
    console.warn('[Response Code]: ' + e.response.data?.code);

    return Promise.reject({
      error: e,
      status,
      message,
    });
  } else if (e.request) {
    console.warn('Request error: ', e);
  } else {
    console.warn('Axios error: ', e);
  }

  throw e;
};

export default request;
